import { FunctionComponent } from "react";

export interface RadioButtonProps {
  isActive: any;
  label: string;
  error?: boolean;
  errorText?: String;
  setValue: Function;
}

const RadioButton: FunctionComponent<RadioButtonProps> = ({
  isActive,
  setValue,
  label,
  error,
  errorText,
}) => {
  return (
    <div
      className={`btn small ${
        isActive ? "btn-outline-active" : "btn-outline"
      } text-center`}
      onClick={() => setValue()}
    >
      <label className="text-left cursor-pointer">
        <input
          type="radio"
          className="hidden"
          checked={isActive}
          onChange={() => setValue()}
        />
        <span>{label}</span>
      </label>
    </div>
  );
};

export default RadioButton;
